import {IStore} from "modules/types";
import {createSelector} from "@reduxjs/toolkit";

const getState = ({modalReducer}: IStore) => modalReducer;

export const getErrorModalData = createSelector(getState, (state) => state.errorModal.message);

export const getSuccessModalData = createSelector(getState, (state) => state.successModalData);
export const getPlayerModalData = createSelector(getState, (state) => state.playerModal.playerId);
export const getIsOpenSSOAdditionalFieldsModal = createSelector(
	getState,
	(state) => state.isOpenSSOAdditionalFieldsModal
);

export const getIsOpenDontLoseTeamModal = createSelector(
	getState,
	(state) => state.isOpenDontLoseTeamModal
);

export const getIsOpenPlayerDetailsModal = createSelector(
	getState,
	(state) => state.playerDetailsModal
);

export const getFanVoteModalData = createSelector(getState, (state) => state.fanVoteSavedModal);

export const getIsOpenConfirmPicksModal = createSelector(
	getState,
	(state) => state.isOpenConfirmPicksModal
);
